import { Component, Input, OnInit, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { Amparo } from '../../../Modelos/Amparo';
import { AmparosService } from './amparos.service';
import { environment } from 'src/environments/environment';
import { ProductoService } from '../producto.service';
import { Ramo } from 'src/app/configuraciones/Ramo';
import { ConfiguracionesService } from 'src/app/configuraciones/configuraciones.service';

declare let abrirModal: Function;
declare let cerrarModal: Function;
declare let inicializarModales: Function;
declare let actualizarCampos: Function;
declare let renderizarDatePickers: Function;
declare let desactivarFechas: Function;
declare let obtenerFecha: Function;
declare let mostrarToast: Function;
declare let convertirAMoneda: Function;
declare let convertirAFecha: Function;

@Component({
    selector: 'amparos',
    templateUrl: 'amparos.component.html',
    styleUrls: ["amparos.component.css"]
})
export class AmparosComponent implements OnInit, OnChanges {
    @Input() amparos: Amparo[];
    @Input() valorContrato: string;
    @Input() fechaExpedicion: string;
    @Input() fechaFinContrato: string;
    @Input() fechaVigenciaDesde: string;
    @Input() codigoRamo: number;
    @Input() flagEmision: boolean;
    @Input() seriedadOferta: boolean;
    @Input() codigoSucursal: number;
    @Input() objetoContrato: number;
    @Output() restablecerObjetoContrato = new EventEmitter();
    amparoABorrar: Amparo;
    totalSumaAsegurada: number;
    totalPrimaNeta: number;
    unidadesDuracionAmparo = [];
    amparosDisponibles: Amparo[];
    amparoSeleccionado: Amparo;
    idAmparoSeleccionadoModal: number;
    editarAmparoFlag: boolean;
    tipoTasaSeleccionado: boolean;
    hayAmparosActivos: boolean;
    tasas: any[];
    deducibles: any[];
    arrayRamos: Ramo[];

    constructor(private amparosService: AmparosService, private productosService: ProductoService, private configuracionService : ConfiguracionesService) {}

    async ngOnInit() {
        this.amparosDisponibles = [];
        this.arrayRamos = this.configuracionService.arrayRamos;
        this.idAmparoSeleccionadoModal = null;
        inicializarModales();
        this.unidadesDuracionAmparo = [
            {nombre: 'Días', valor: 1},
            {nombre: 'Meses', valor: 2},
            {nombre: 'Años', valor: 3}
        ];

        this.tasas = await this.amparosService.consultarTasa();
        this.tasas = this.tasas.filter(x => [1 /*Porcentaje*/, 3 /*Importe*/].includes(x.codigo_tipo_tasa));

        this.totalSumaAsegurada = 0;
        this.totalPrimaNeta = 0;

        this.tipoTasaSeleccionado = false;
        this.hayAmparosActivos = false;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.hasOwnProperty('amparos') && [45, 47, 74].includes(this.codigoRamo)) {
            if (this.amparos.length > 0 && !this.flagEmision) {
                this.amparoSeleccionado = this.amparos.find(x => x.es_obligatorio === -1);
                this.abrirModalEditarAmparo(this.amparoSeleccionado);
                this.hayAmparosActivos = false;
                this.tipoTasaSeleccionado = false;
                this.consultarDeducibles();
            }
        }
        if (changes.hasOwnProperty('objetoContrato')) {
            if (changes.objetoContrato.currentValue == null) {
                this.hayAmparosActivos = false;
            }
        }
    }

    validarValorAsegurado() {
        if (this.amparoSeleccionado.valor_asegurado) {
            this.amparoSeleccionado.valor_asegurado = convertirAMoneda(this.amparoSeleccionado.valor_asegurado);
        }
    }

validarPorcentajeContrato() {
    if (
        this.amparoSeleccionado == null ||
        this.amparoSeleccionado.porcentaje_contrato == null ||
        this.amparoSeleccionado.porcentaje_contrato === ''
    ) {
        return;
    }

    const limitePorcentaje = this.codigoRamo === 74 ? 200 : 100;

    let porcentajeTexto = this.amparoSeleccionado.porcentaje_contrato
        .toString()
        .replace(',', '.')
        .replace(/[^0-9.]/g, '');

    let porcentaje = Number(porcentajeTexto);

    if (isNaN(porcentaje)) {
        this.amparoSeleccionado.porcentaje_contrato = '';
        mostrarToast('Ingrese un porcentaje válido.');
        return;
    }

    if (porcentaje > limitePorcentaje) {
        mostrarToast(`El porcentaje no puede ser mayor a ${limitePorcentaje}.`);
        porcentaje = limitePorcentaje;
    }

    if (porcentaje < 0) {
        porcentaje = 0;
    }

    this.amparoSeleccionado.porcentaje_contrato = porcentaje.toString();
}

    obtenerValorFechaVigenciaDesde() {
        this.amparoSeleccionado.fecha_vigencia_desde = obtenerFecha('FechaVigenciaDesdeAmparo');
        actualizarCampos();
    }

    calcularFechaVigenciaHasta() {
        const tieneDuracion =
            Number(this.amparoSeleccionado.aaaa) > 0 ||
            Number(this.amparoSeleccionado.mm) > 0 ||
            Number(this.amparoSeleccionado.dd) > 0;

        if (!tieneDuracion) {
            return;
        }

        const fecha = this.amparoSeleccionado.fecha_vigencia_desde.split('/');
        const año = Number(fecha[2]);
        const mes = Number(fecha[1]) - 1;
        const dia = Number(fecha[0]);

        this.amparoSeleccionado.fecha_vigencia_hasta = new Date(
            año + Number(this.amparoSeleccionado.aaaa),
            mes + Number(this.amparoSeleccionado.mm),
            dia + Number(this.amparoSeleccionado.dd)
        ).toLocaleDateString('es-CO', {});

        this.calcularTotalDias();

        if (this.amparoSeleccionado.total_dias > this.amparoSeleccionado.dias_inicio_vigencia) {
            mostrarToast('Se ha excedido el número máximo de días.');

            this.amparoSeleccionado.aaaa = 0;
            this.amparoSeleccionado.mm = 0;
            this.amparoSeleccionado.dd = 0;
            this.amparoSeleccionado.fecha_vigencia_hasta = '';

            actualizarCampos();
        }
    }

    async consultarDeducibles() {
        this.deducibles = await this.amparosService.consultarDeducible(this.codigoRamo);
    }

    calcularTotalDias() {
        let dia = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        const fd = this.amparoSeleccionado.fecha_vigencia_desde.split('/').map(x => Number(x));
        const fechaDesde = new Date(fd[2], fd[1] - 1, fd[0]);
        const fh = this.amparoSeleccionado.fecha_vigencia_hasta.split('/').map(x => Number(x));
        const fechaHasta = new Date(fh[2], fh[1] - 1, fh[0]);
        dia = Math.round(Math.abs((fechaHasta.getTime() - fechaDesde.getTime()) / (dia)));
        this.amparoSeleccionado.total_dias = dia;
    }

    abrirModalEditarAmparo(amparo: Amparo) {
        this.amparoSeleccionado = Object.create(amparo);
        this.idAmparoSeleccionadoModal = amparo.id_amparo;
        this.abrirModalAmparos(true);
        if (this.amparos.filter(x => x.activo).length === 1) {
            this.tipoTasaSeleccionado = false;
        }
        setTimeout(() => renderizarDatePickers(), 5);
    }

    abrirModalAmparos(editarAmparo: boolean = false) {
        this.editarAmparoFlag = editarAmparo;
        abrirModal('modalAgregarAmparo', false);
        if (editarAmparo) {
            setTimeout( () => this.desactivarFechasVigenciaDesde(), 500);
        } else {
            this.amparosDisponibles = this.amparos.filter(a => !a.activo);
            this.idAmparoSeleccionadoModal = null;
            this.amparoSeleccionado = null;
        }
        actualizarCampos();
    }

    encontrarAmparoSeleccionado() {
        this.amparoSeleccionado = this.amparosDisponibles.find(x => x.id_amparo === this.idAmparoSeleccionadoModal);
        this.restablecerAmparo(this.amparoSeleccionado);
        if (this.codigoRamo === 74 && this.amparos.filter(x => x.activo).length >= 1) {
            const amparo = this.amparos.find(x => x.id_amparo === this.amparoSeleccionado.id_amparo);
            amparo.activo = true;
            this.cerrarModalAmparos();
            return;
        }
        actualizarCampos();
        setTimeout(() => {
            renderizarDatePickers();
            this.desactivarFechasVigenciaDesde();
        }, 50);
    }

    desactivarFechasVigenciaDesde() {
        const fc = this.fechaVigenciaDesde.split('/').map(x => Number(x));
        desactivarFechas('FechaVigenciaDesdeAmparo', new Date(fc[2], fc[1] - 1, fc[0]));
    }

    agregarAmparo() {
            if (!this.validarFechaFinContrato(true)) {
        return;
    }
        if (this.amparoSeleccionado.valido) {
            const amparo = this.amparos.find(x => x.id_amparo === this.amparoSeleccionado.id_amparo);
            amparo.activo = true;
            this.calcularSumaAsegurada();
            this.calcularValorPrimaNeta();
            this.cerrarModalAmparos();
            if (this.amparos.filter(x => x.activo).length === 1) {
                this.tipoTasaSeleccionado = true;
                this.hayAmparosActivos = true;
                this.definirTiposTasa(this.amparos[0]);
            }
            this.amparosDisponibles = this.amparos.filter(a => !a.activo);
        } else {
            mostrarToast('El amparo no es válido aún.');
        }
    }

    editarAmparo() {
        if (!this.validarFechaFinContrato(true)) {
            return;
        }
        if (this.amparoSeleccionado.valido) {
            this.amparoSeleccionado.activo = true;
            const index = this.amparos.findIndex(x => x.id_amparo === this.amparoSeleccionado.id_amparo);
            this.amparos[index] = this.amparoSeleccionado;
            this.calcularSumaAsegurada();
            this.calcularValorPrimaNeta();
            this.cerrarModalAmparos();
            if (this.amparos.filter(x => x.activo).length === 1) {
                this.tipoTasaSeleccionado = true;
                this.hayAmparosActivos = true;
                this.definirTiposTasa(this.amparos[0]);
            }
            this.amparosDisponibles = this.amparos.filter(a => !a.activo);
        } else {
            mostrarToast('El amparo no es válido aún.');
        }
    }

    cerrarModalAmparos(cancelarFlag: boolean = false) {
        if (this.amparoSeleccionado != null) {
            const numeroAmparosActivos = this.amparos.filter(x => x.activo).length;
            if (this.amparoSeleccionado.es_obligatorio === -1 && numeroAmparosActivos === 0 && cancelarFlag) {
                this.amparos = [];
                this.restablecerObjetoContrato.emit();
            }
        }
        cerrarModal('modalAgregarAmparo');
    }

    abrirModalBorrarAmparo(amparo: Amparo) {
        this.amparoABorrar = amparo;
        abrirModal('modalConfirmarBorradoAmparo');
    }

    cerrarModalBorrarAmparo() {
        this.amparoABorrar = null;
        cerrarModal('modalConfirmarBorradoAmparo');
    }

    borrarAmparo(amparo: Amparo) {
        const index = this.amparos.findIndex(x => x.id_amparo === amparo.id_amparo);
        this.amparos[index].activo = false;
        this.calcularSumaAsegurada();
        this.calcularValorPrimaNeta();
        this.cerrarModalBorrarAmparo();
        if (this.amparos.filter(x => x.activo).length === 0) {
            this.hayAmparosActivos = false;
            this.restablecerObjetoContrato.emit();
        }
    }

    definirTiposTasa(amparo: Amparo) {
        this.amparos.forEach(x => {
            x.tipo_tasa = amparo.tipo_tasa;
            if (amparo.tipo_tasa === 3 && x.id_amparo !== amparo.id_amparo) {
                x.vr_tasa_accesos = '';
            }
        });
    }

    validarAmparoRCE() {
        this.amparoSeleccionado.valido = true;
        if (this.amparos.filter(x => x.activo).length > 0) {
            return;
        }
        if (!this.amparoSeleccionado.valor_asegurado || !this.amparoSeleccionado.cod_deducible) {
            this.amparoSeleccionado.valido = false;
        }
    }

cambiarFechaVigenciaHastaManual(validarAlSalir: boolean = false) {
    if (!this.amparoSeleccionado.fecha_vigencia_hasta) {
        return;
    }

    if (!this.validarFechaManual('fecha_vigencia_hasta', validarAlSalir)) {
        return;
    }

    this.amparoSeleccionado.aaaa = 0;
    this.amparoSeleccionado.mm = 0;
    this.amparoSeleccionado.dd = 0;

    this.calcularTotalDias();
    this.validarFechaFinContrato();
    this.validarPorcentajeTasa();

    actualizarCampos();
}

validarFechaFinContrato(mostrarMensaje: boolean = true): boolean {
    if (!this.amparoSeleccionado.fecha_vigencia_hasta || !this.fechaFinContrato) {
        return true;
    }

    const fechaHastaAmparo = convertirAFecha(this.amparoSeleccionado.fecha_vigencia_hasta);
    const fechaFinContrato = convertirAFecha(this.fechaFinContrato);

    if (fechaHastaAmparo < fechaFinContrato) {
        if (mostrarMensaje) {
            mostrarToast('La fecha fin del amparo debe ser igual o mayor a la fecha fin del contrato.');
        }

        this.amparoSeleccionado.valido = false;
        return false;
    }

    return true;
}

async resolverTasa() {
    if (!this.amparoSeleccionado || !this.amparoSeleccionado.tipo_tasa) {
        return;
    }

    if (this.amparoSeleccionado.tipo_tasa === 1) {
        let amparos = await this.productosService.consultarAmparos(
            this.codigoRamo,
            this.codigoSucursal,
            '1',
            this.objetoContrato
        );

        amparos = amparos.map(x => this.construirAmparo(x));

        const amparo = amparos.find(x =>
            x.id_amparo === this.amparoSeleccionado.id_amparo
        );

        if (amparo) {
            this.amparoSeleccionado.vr_tasa_accesos = amparo.vr_tasa_accesos;
        } else {
            this.amparoSeleccionado.vr_tasa_accesos = '';
            mostrarToast('No se encontró la tasa para el amparo seleccionado.');
        }
    }

    if (this.amparoSeleccionado.tipo_tasa === 3) {
        this.amparoSeleccionado.vr_tasa_accesos = '';
    }

    this.amparoSeleccionado.valor_prima = '';
    this.changeForm();
}

    construirAmparo(amparo) {
        amparo.id_amparo = Number(`${amparo.codigo_amparo}${amparo.codigo_objeto}${amparo.codigo_ramo_tec}${amparo.codigo_subramo}`);
        amparo.descripcion_amparo = (this.codigoRamo === 74) ? amparo.descripcion_amparo : amparo.descripcion_subramo;
        amparo.cod_deducible = null;
        amparo.suma_es_porcentaje = false;
        amparo.valido = false;
        amparo.aaaa = 0;
        amparo.mm = 0;
        amparo.dd = 0;
        amparo.total_dias = 1;
        amparo.tipo_calculo = 1;
        amparo.tipo_tasa = null;
        amparo.vr_prima_minima = 0;
        amparo.dias_inicio_vigencia = (amparo.dias_inicio_vigencia === 0) ? 3650 : amparo.dias_inicio_vigencia;
        return amparo;
    }

changeForm() {
    if (!this.amparoSeleccionado) {
        return;
    }

    const valorContrato = parseFloat((this.valorContrato || '0').replace(/,/g, ''));

    if (this.amparoSeleccionado.suma_es_porcentaje) {
        const porcentaje = Number(this.amparoSeleccionado.porcentaje_contrato || 0);
        const limitePorcentaje = this.codigoRamo === 74 ? 200 : 100;

        if (porcentaje > limitePorcentaje) {
            mostrarToast(`El porcentaje no puede ser mayor a ${limitePorcentaje}.`);
            this.amparoSeleccionado.porcentaje_contrato = limitePorcentaje.toString();

            const valorAsegurado = valorContrato * limitePorcentaje / 100;
            this.amparoSeleccionado.valor_asegurado = convertirAMoneda(valorAsegurado + '');
        } else {
            const valorAsegurado = valorContrato * porcentaje / 100;
            this.amparoSeleccionado.valor_asegurado = convertirAMoneda(valorAsegurado + '');
        }
    } else if (this.amparoSeleccionado.valor_asegurado) {
        if (this.codigoRamo !== 74) {
            const valorAsegurado = parseFloat(
                this.amparoSeleccionado.valor_asegurado.replace(/,/g, '')
            );

            if (valorAsegurado > valorContrato) {
                mostrarToast('El valor asegurado no puede ser mayor al valor del contrato.');
                this.amparoSeleccionado.valor_asegurado = convertirAMoneda(valorContrato + '');
            }
        }
    }

    this.validarValorAsegurado();

    // Ya no usamos obtenerFecha porque quitamos el datepicker.
    // this.obtenerValorFechaVigenciaDesde();

    this.calcularFechaVigenciaHasta();

    if (this.amparoSeleccionado.fecha_vigencia_hasta) {
        if (!this.validarFechaFinContrato(false)) {
            return;
        }
    }

    this.validarPorcentajeTasa();

    if (this.codigoRamo === 74) {
        this.validarAmparoRCE();
        actualizarCampos();
        return;
    }

    if (this.amparoSeleccionado.es_Postcontractual) {
        if (
            this.amparoSeleccionado.fecha_vigencia_desde &&
            convertirAFecha(this.amparoSeleccionado.fecha_vigencia_desde) < convertirAFecha(this.fechaVigenciaDesde)
        ) {
            mostrarToast('La fecha de vigencia desde no puede ser inferior a la fecha de vigencia desde.');
            this.amparoSeleccionado.valido = false;
            return;
        }
    }

    this.amparoSeleccionado.valido = true;

    if (
        !this.amparoSeleccionado.valor_asegurado ||
        !this.amparoSeleccionado.fecha_vigencia_desde ||
        !this.amparoSeleccionado.fecha_vigencia_hasta ||
        !this.amparoSeleccionado.total_dias ||
        !this.amparoSeleccionado.tipo_tasa ||
        !this.amparoSeleccionado.vr_tasa_accesos ||
        !this.amparoSeleccionado.valor_prima
    ) {
        this.amparoSeleccionado.valido = false;
    }

    actualizarCampos();
}

    calcularSumaAsegurada() {
        let valorAsegurado = 0;
        this.amparos.forEach(amparo => {
            if (amparo.valor_asegurado && amparo.activo) {
                valorAsegurado += parseFloat(amparo.valor_asegurado.replace(/,/g, ''));
            }
        });
        this.totalSumaAsegurada = valorAsegurado;
        this.validarSumaTotalAsegurada();
    }

formatearFechaManual(
    event: any,
    campo: 'fecha_vigencia_desde' | 'fecha_vigencia_hasta'
) {
    let valor = event.target.value.replace(/\D/g, '');

    if (valor.length > 2) {
        valor = valor.substring(0, 2) + '/' + valor.substring(2);
    }

    if (valor.length > 5) {
        valor = valor.substring(0, 5) + '/' + valor.substring(5, 9);
    }

    this.amparoSeleccionado[campo] = valor;

    if (valor.length === 10 && this.validarFechaManual(campo, false)) {
        if (campo === 'fecha_vigencia_hasta') {
            this.cambiarFechaVigenciaHastaManual(false);
        }

        if (campo === 'fecha_vigencia_desde') {
            this.changeForm();
        }
    }
}

validarFechaManual(
    campo: 'fecha_vigencia_desde' | 'fecha_vigencia_hasta',
    mostrarMensaje: boolean = true
): boolean {
    const valor = this.amparoSeleccionado[campo];

    if (!valor || valor.length !== 10) {
        return false;
    }

    const partes = valor.split('/');
    const dia = Number(partes[0]);
    const mes = Number(partes[1]);
    const anio = Number(partes[2]);

    const fecha = new Date(anio, mes - 1, dia);

    const esValida =
        fecha.getFullYear() === anio &&
        fecha.getMonth() === mes - 1 &&
        fecha.getDate() === dia;

    if (!esValida) {
        this.amparoSeleccionado[campo] = '';

        if (mostrarMensaje) {
            mostrarToast('La fecha ingresada no es válida.');
        }

        return false;
    }

    return true;
}

    calcularValorPrimaNeta() {
        let valorPrima = 0;
        this.amparos.forEach(amparo => {
            if (amparo.valor_prima && amparo.activo) {
                valorPrima += parseFloat(amparo.valor_prima.replace(/,/g, ''));
            }
        });
        this.totalPrimaNeta = valorPrima;
    }

    validarPorcentajeTasa() {
        let valorPrima = 0;
        if (this.amparoSeleccionado.tipo_tasa === 1 && this.amparoSeleccionado.valor_asegurado) { // Porcentaje
            const divisor = this.tasas.find(x => x.codigo_tipo_tasa === this.amparoSeleccionado.tipo_tasa).numero_divisor;
            const valorAsegurado = parseFloat(this.amparoSeleccionado.valor_asegurado.replace(/,/g, ''));
            const porcentajeTasa = parseFloat(this.amparoSeleccionado.vr_tasa_accesos);
            const diasAño = 365;

            valorPrima = (valorAsegurado * porcentajeTasa);
            if (!this.seriedadOferta) {
                valorPrima = ((valorPrima / divisor) / diasAño) * this.amparoSeleccionado.total_dias;
            } else {
                valorPrima = valorPrima / 100;
            }
            if (!this.amparoSeleccionado.vr_tasa_accesos.toString().includes('.')) {
                this.amparoSeleccionado.vr_tasa_accesos += '.00';
            }
        } else if (this.amparoSeleccionado.tipo_tasa === 3 && this.amparoSeleccionado.vr_tasa_accesos) { // Importe
            valorPrima = parseFloat(this.amparoSeleccionado.vr_tasa_accesos.toString().replace(/,/g, ''));
        }

        this.amparoSeleccionado.vr_tasa_accesos = convertirAMoneda(this.amparoSeleccionado.vr_tasa_accesos);
        this.amparoSeleccionado.valor_prima = convertirAMoneda(valorPrima.toString());
    }

    restablecerAmparo(amparo: Amparo): void {
        amparo.suma_es_porcentaje = false;
        amparo.porcentaje_contrato = '';
        amparo.valor_asegurado = '';
        amparo.fecha_vigencia_desde = (amparo.es_Postcontractual === -1) ? this.fechaFinContrato : this.fechaVigenciaDesde;
        amparo.fecha_vigencia_hasta = '';
        amparo.aaaa = 0;
        amparo.mm = 0;
        amparo.dd = 0;
        amparo.valor_prima = '';
        if (!this.tipoTasaSeleccionado) {
            amparo.tipo_tasa = null;
        }
    }

    convertirATextoMoneda(texto) {
        return convertirAMoneda(texto + '');
    }

    validarSumaTotalAsegurada() {
        let valorMaximo = 0;
        if (this.codigoRamo === 45)
          valorMaximo = this.arrayRamos.find(objeto => objeto.iN_cod_ramo === 45).nM_ValorTope;
        if (this.codigoRamo === 47)
         valorMaximo = this.arrayRamos.find(objeto => objeto.iN_cod_ramo === 47).nM_ValorTope;
        if (this.codigoRamo === 74)
          valorMaximo = this.arrayRamos.find(objeto => objeto.iN_cod_ramo === 74).nM_ValorTope;
        if (this.totalSumaAsegurada > valorMaximo) {
            mostrarToast(`El valor asegurado supera ${convertirAMoneda(valorMaximo.toString())}.`);
        }
    }

}
